import { BaseEntity } from './base.entity';

export class NotificationEntity implements BaseEntity {
  key!: string;
  createdAt!: Date;
  updatedAt!: Date;
  projectKey!: string;
  cardKey!: string;
  chats: number =0;
  client!: string;
  board!: string;
  boardKey!: string;
  boardIcon!: string;
  card!: string;
  changedBy!: string;
  status!: string;
  statusPrevious!: string;
  type!: 'chat' | 'assigned' | 'yours'
  recipientName!: string;
  recipientKey!: string;
  sender?: string; // User who created the notification
}
